var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatboxEllipses = function SvgChatboxEllipses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M4.873 2.25h14.252V3l.002-.75A3.383 3.383 0 0 1 22.5 5.623v9.004A3.38 3.38 0 0 1 19.127 18H11.52L7.23 21.576A.75.75 0 0 1 6 21v-3H4.873A3.38 3.38 0 0 1 1.5 14.627V5.623A3.383 3.383 0 0 1 4.873 2.25m14.25 1.5H4.877A1.883 1.883 0 0 0 3 5.626v8.998A1.88 1.88 0 0 0 4.876 16.5H6.75a.75.75 0 0 1 .75.75v2.148l3.162-2.636c.203-.17.458-.262.722-.262h7.74A1.883 1.883 0 0 0 21 14.624V5.626a1.883 1.883 0 0 0-1.876-1.876",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    d: "M7.5 11.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 11.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 11.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export default SvgChatboxEllipses;